var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3041 12.3103C16.1787 13.263 15.7108 14.1376 14.9878 14.7706C14.2647 15.4036 13.336 15.7517 12.375 15.75C6.79219 15.75 2.25001 11.2078 2.25001 5.62498C2.24828 4.66401 2.59643 3.73528 3.22941 3.01223C3.8624 2.28919 4.73694 1.82129 5.68969 1.69592C5.93062 1.6665 6.1746 1.71579 6.38522 1.83643C6.59583 1.95707 6.76178 2.14259 6.85829 2.36529L8.34329 5.68053V5.68896C8.41718 5.85944 8.44769 6.04556 8.43211 6.23071C8.41653 6.41585 8.35533 6.59425 8.25399 6.74998C8.24133 6.76896 8.22797 6.78654 8.21391 6.80412L6.75001 8.53943C7.27665 9.60959 8.39602 10.7191 9.48024 11.2472L11.1916 9.791C11.2085 9.77687 11.2261 9.76372 11.2444 9.75162C11.4 9.64784 11.579 9.58449 11.7652 9.56731C11.9515 9.55012 12.1391 9.57963 12.311 9.65318L12.3202 9.6574L15.6326 11.1417C15.8557 11.2379 16.0417 11.4037 16.1627 11.6143C16.2837 11.825 16.3333 12.0691 16.3041 12.3103Z",
    fill: "#8A7C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.69f08f8b2546d51981f33b9e6d150a7a.svg";
export { ForwardRef as ReactComponent };